import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipDetail } from "../user.api";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

export default function InternshipApplicationDetails(props) {
  const { id } = useParams();
  const history = useHistory();
  const [application, setApplication] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const fetchDetails = (appId) => {
    setIsLoading(true);
    myInternshipDetail(appId)
      .then((res) => {
        if (res?.success) {
          setApplication(res.data);
        } else {
          setSnackMessage("Failed to load application details");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching details:", error);
        setSnackMessage("Error loading application details");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  if (isLoading) return <Loader open={isLoading} />;

  if (!application) return (
    <div className="container mt-5 text-center">
      <h4>No application details found</h4>
      <button className="btn btn-minimal-dark mt-3" onClick={() => history.push("/internship-applied")}>Back to List</button>
    </div>
  );

  return (
    <div className="registered-internships-page">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner-minimal">
        <div className="tit-txt">
          {props.state.language === "ma" ? "അപേക്ഷാ വിവരങ്ങൾ" : "Application Details"}
        </div>
      </div>

      <BreadCrumpBack />
      
      <div className="container mt-4 mb-5 p-50">
        <div className="d-flex justify-content-between align-items-center mb-5">
           <h5 className="fw-bold text-dark">
             {props.state.language === "ma" ? "അപേക്ഷകന്റെ വിവരങ്ങൾ" : "Applicant Information"}
           </h5>
           <button className="btn btn-minimal-outline btn-sm" onClick={() => history.push("/internship-applied")}>
             Back to List
           </button>
        </div>

        <div className="row">
          {/* Left Column: Minimal Profile Sidebar */}
          <div className="col-lg-4 mb-4">
            <div className="section-card-minimal">
              <div className="section-header">Summary</div>
              <div className="card-body p-4 text-center">
                <div className="mb-4">
                  {application.file_upload_photo ? (
                    <img 
                      src={application.file_upload_photo} 
                      alt="Profile" 
                      className="profile-img-minimal"
                    />
                  ) : (
                    <div className="profile-img-minimal bg-light d-inline-flex align-items-center justify-content-center">
                      <span className="h1 text-muted mb-0">{application.full_name?.charAt(0)}</span>
                    </div>
                  )}
                </div>
                <h5 className="fw-bold mb-1">{application.full_name}</h5>
                <p className="small text-muted mb-4 opacity-75">ID: {application.id}</p>
                
                <div className="text-start">
                   <div className="info-item-minimal mb-3">
                      <label>Email Address</label>
                      <span>{application.email}</span>
                   </div>
                   <div className="info-item-minimal mb-3">
                      <label>Contact Number</label>
                      <span>{application.phone_no}</span>
                   </div>
                   <div className="info-item-minimal mb-3">
                      <label>Registration Date</label>
                      <span>{moment(application.created_at).format("DD MMM YYYY")}</span>
                   </div>
                </div>

                <div className="mt-4 pt-3 border-top">
                  {application.resume && (
                    <a href={application.resume} target="_blank" rel="noreferrer" className="btn btn-minimal-dark w-100 shadow-sm">
                      View Portfolio/Resume
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* Institution Section */}
            <div className="section-card-minimal">
              <div className="section-header">Institution</div>
              <div className="card-body p-4">
                {application.institution && application.institution.length > 0 ? (
                  application.institution.map((inst, idx) => (
                    <div key={idx} className="mb-3 last-child:mb-0">
                      <div className="info-item-minimal mb-2">
                        <label>Institute Name</label>
                        <span>{inst.institution_name}</span>
                      </div>
                      <div className="info-item-minimal">
                        <label>Ref No</label>
                        <span>{inst.unique_application_ref_no || "N/A"}</span>
                      </div>
                    </div>
                  ))
                ) : <div className="text-muted small italic">No institution details</div>}
              </div>
            </div>
          </div>

          {/* Right Column: Main Content Details */}
          <div className="col-lg-8">
            {/* Extended Details Grid */}
            <div className="section-card-minimal">
              <div className="section-header">Personal Information</div>
              <div className="info-grid-minimal">
                 <div className="info-item-minimal">
                   <label>Gender</label>
                   <span>{application.gender || "Not specified"}</span>
                 </div>
                 <div className="info-item-minimal">
                   <label>Date of Birth</label>
                   <span>{moment(application.date_of_birth).format("DD MMM YYYY")}</span>
                 </div>
                 <div className="info-item-minimal">
                   <label>Native of Kerala</label>
                   <span>{application.is_kerala_native ? "Yes" : "No"}</span>
                 </div>
                 <div className="info-item-minimal">
                   <label>Applied via</label>
                   <span>{application.course_completion_status || "Standard"}</span>
                 </div>
                 <div className="info-item-minimal col-span-2">
                   <label>Permanent Address</label>
                   <span>{application.address}</span>
                 </div>
              </div>
            </div>

            {/* Qualifications Card */}
            <div className="section-card-minimal">
              <div className="section-header">Qualifications</div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="bg-light text-muted small">
                      <tr>
                        <th className="border-0 px-4 py-3">Academic Info</th>
                        <th className="border-0 py-3">Stream / Category</th>
                        <th className="border-0 py-3">Result</th>
                        <th className="border-0 py-3 px-4 text-end">Documents</th>
                      </tr>
                    </thead>
                    <tbody className="small">
                      {application.intern_qualification && application.intern_qualification.map((q, idx) => (
                        <tr key={idx}>
                          <td className="px-4 py-3">
                             <div className="fw-bold">{q.qualification?.name}</div>
                             <div className="text-muted x-small">{q.qualification_type?.name}</div>
                          </td>
                          <td className="py-3">
                             <div className="fw-bold">{q.stream?.name}</div>
                             <div className="text-muted x-small">Board: {q.board} • Year: {q.year_passed}</div>
                          </td>
                          <td className="py-3">
                             <div>CGPA: {q.marks && q.marks[0] ? q.marks[0].cgpa : '--'}</div>
                          </td>
                          <td className="text-end px-4 py-3">
                             {q.certificate_photo && (
                               <a href={q.certificate_photo} target="_blank" rel="noreferrer" className="btn btn-minimal-outline btn-sm py-1 px-3">
                                 View Proof
                               </a>
                             )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Internships Applied Card */}
            <div className="section-card-minimal">
              <div className="section-header">Applied Internships & Rankings</div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0 text-dark">
                    <thead className="bg-light text-muted small">
                      <tr>
                        <th className="border-0 px-4 py-3">Ref</th>
                        <th className="border-0 py-3">Internship Description</th>
                        <th className="border-0 py-3">Rank / Status</th>
                      </tr>
                    </thead>
                    <tbody className="small">
                      {application.proposals && application.proposals.map((p, idx) => (
                        <tr key={idx}>
                          <td className="px-4 py-3 fw-bold text-muted">0{p.preference_order}</td>
                          <td className="py-3">
                            <div className="fw-bold">{p.internship_request?.internship_discipline}</div>
                            <div className="text-muted x-small">{p.internship_request?.company?.company_name}</div>
                          </td>
                          <td className="py-3">
                            <span className={`status-badge-minimal ${p.status === 'pending' ? 'pending' : 'approved'}`}>
                              {p.status}
                            </span>
                            <div className="text-muted x-small mt-1">My Rank: #{p.my_rank || "--"}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
